import { Icons } from '@/assets'
import { ROUTES } from '@/constants/routes'
import type { FC, SVGProps } from 'react';

export interface NavItemConfig {
  id: string
  icon: FC<SVGProps<SVGSVGElement>>;
  label: string
  path: string
}

export const MAIN_MENU: NavItemConfig[] = [
  { id: 'dashboard', icon: Icons.DashboardIcon, label: "Dashboard", path: ROUTES.MAIN.DASHBOARD },
  { id: 'builder', icon: Icons.BuilderIcon, label: "Builder", path: ROUTES.MAIN.BUILDER },
  { id: 'project-compliance', icon: Icons.ProjectComplianceIcon, label: "Project Compliance", path: ROUTES.MAIN.PROJECTCOMPLIANCE },
  { id: 'escrow-payment', icon: Icons.DollarIcon, label: "Escrow Payment", path: ROUTES.MAIN.ESCROWPAYMENT },
  { id: 'buyer', icon: Icons.BuyerIcon, label: "Buyer", path: ROUTES.MAIN.BUYER },
  { id: 'broker', icon: Icons.BrokerIcon, label: "Broker", path: ROUTES.MAIN.BROKER },
  { id: 'leadVisitTriage', icon: Icons.LeadVisitTriageIcon, label: "Lead & Visit", path: ROUTES.MAIN.LeadVisitTriage },
  { id: 'leads', icon: Icons.LeadsIcon, label: "Leads", path: ROUTES.MAIN.LEADS },
  { id: 'communication', icon: Icons.CommunicationIcon, label: "Communication", path: ROUTES.MAIN.Communication },
  { id: 'disputesIncidents', icon: Icons.DisputesIcon, label: "Disputes & Incidents", path: ROUTES.MAIN.Disputes },
  { id: 'auditReports', icon: Icons.AuditReportIcon, label: "Audit & Reports", path: ROUTES.MAIN.AUDITREPORTS },
  { id: 'bank', icon: Icons.BankIcon, label: "Bank", path: ROUTES.MAIN.BANK },
  { id: 'inquiries', icon: Icons.InquiriesIcon, label: "Inquiries", path: ROUTES.MAIN.INQUIRIES },
  { id: 'wallet', icon: Icons.WalletIcon, label: "Wallet", path: ROUTES.MAIN.WALLET },
  { id: 'gallery', icon: Icons.GalleryIcon, label: "Gallery", path: ROUTES.MAIN.GALLERY },
  { id: 'team', icon: Icons.TeamIcon, label: "Team", path: ROUTES.MAIN.TEAM },
  { id: 'analytics', icon: Icons.AnalyticsIcon, label: "Analytics", path: ROUTES.MAIN.ANALYTICS },
];

export const BOTTOM_MENU: NavItemConfig[] = [
  { id: 'info', icon: Icons.InfoIcon, label: "Info", path: ROUTES.BOTTOM.INFO },
  { id: 'settings', icon: Icons.SettingIcon, label: "Settings", path: ROUTES.BOTTOM.SETTINGS },
];

